import { AnyComparator, CompleteCondition, DateComparator, FieldType } from '../types';
import { validateIsRelativeDate } from './validateIsRelativeDate';

// TODO Clean up these functions, mostly moved over from Angular

/*------------------------------------------------------------------------------------------------*/
/* Helper functions for handling inBetween date comparator                                        */
/*------------------------------------------------------------------------------------------------*/
/**
 *
 * @param searchQueries
 * @returns searchQueries with inBetween comparator conditions if applicable
 */
export const parseForInBetweenDates = (searchQueries: CompleteCondition[]) => {
  const singleSearchQueries: CompleteCondition[] = [];
  const absoluteDateFields: Record<string, any> = {};
  const absoluteDateFieldCopies: Record<string, CompleteCondition> = {};
  searchQueries.forEach((comboFilter) => {
    const { comparatorType, fieldType, field } = comboFilter;
    const value = 'value' in comboFilter && !!comboFilter.value ? comboFilter.value : '';
    const isRelativeDate = validateIsRelativeDate(value?.toString());
    if (
      fieldType === FieldType.DATE &&
      !isRelativeDate &&
      (comparatorType === DateComparator.IS_AFTER || comparatorType === DateComparator.IS_BEFORE)
    ) {
      if (!absoluteDateFields[field]) {
        absoluteDateFields[field] = {
          GreaterThan: [],
          LessThan: [],
        };
      }
      absoluteDateFields[field][comparatorType.toString()].push(value);
      absoluteDateFieldCopies[field] = comboFilter;
    } else {
      singleSearchQueries.push({ ...comboFilter });
    }
  });
  Object.keys(absoluteDateFields).forEach((fieldDataType) => {
    const { GreaterThan, LessThan } = absoluteDateFields[fieldDataType];
    GreaterThan.sort((a: string, b: string) => Number(b) - Number(a));
    LessThan.sort((a: string, b: string) => Number(a) - Number(b));
    if (GreaterThan.length && LessThan.length && GreaterThan[0] < LessThan[0]) {
      const combinedSearchField = Object.assign(
        { ...absoluteDateFieldCopies[fieldDataType] },
        {
          comparatorType: DateComparator.BETWEEN,

          value: {
            startDate: GreaterThan.shift(),
            endDate: LessThan.shift(),
          },
        },
      );
      singleSearchQueries.push(combinedSearchField);
    }
    // Pushing anything that doesn't get mapped to isBetween back into searchQueries
    GreaterThan.forEach((value: Date) =>
      singleSearchQueries.push(
        Object.assign(
          { ...absoluteDateFieldCopies[fieldDataType] },
          { comparatorType: DateComparator.IS_AFTER, value },
        ),
      ),
    );
    LessThan.forEach((value: Date) =>
      singleSearchQueries.push(
        Object.assign(
          { ...absoluteDateFieldCopies[fieldDataType] },
          { comparatorType: DateComparator.IS_BEFORE, value },
        ),
      ),
    );
  });

  return singleSearchQueries;
};

export const isUsingInBetweenComparator = (comparator: AnyComparator): boolean =>
  comparator === DateComparator.BETWEEN;
